import React from "react";
import { ToastContainer } from "react-toastify";
import AddMarketingBanner from "../../components/Settings/MarketingBanner/AddMarketingBanner";

export const AddMarketingBannerPage = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <AddMarketingBanner />
        </div>
      </div>
    </div>
  );
};
